import { AxiosInstance } from 'axios';

import { OrdersColumnsEnum } from '../../enum/ordersColumns.enum';
import { DeleteItemsInput } from '../../types';
import { GetAllOrdersResponse, Order } from '../../types/Order';
import { PaginationRequest } from '../../types/PaginationRequest';
import { SortRequest } from '../../types/SortRequest';
import { OrderStatuses, ordersEndpoints } from '../../utils/constants';
import { DateRange } from '../../utils/constants/dateRange';
import { axios } from '../axiosInstance';

import { AddNewOrderInput, BulkUpdateOrdersInput, UpdateOrderInput } from './OrdersApi.schema';

class OrdersApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addNewOrder = async (input: AddNewOrderInput): Promise<Order> =>
    this.#requestInstance.post(ordersEndpoints.orders, input);

  deleteOrder = async (orderId: number): Promise<void> =>
    this.#requestInstance.delete(ordersEndpoints.ordersId(orderId));

  getOrders = async (
    data?: PaginationRequest & SortRequest<OrdersColumnsEnum> & { status: OrderStatuses }
  ): Promise<GetAllOrdersResponse> =>
    this.#requestInstance.get(ordersEndpoints.orders, { params: data });

  getAllOrdersById = async (userId: number, order: DateRange): Promise<GetAllOrdersResponse> =>
    this.#requestInstance.get(ordersEndpoints.getAllOrdersById(userId), { params: { order } });

  deleteManyOrders = async (input: DeleteItemsInput): Promise<void> =>
    this.#requestInstance.delete(ordersEndpoints.orders, { data: input });

  updateManyOrders = async (input: BulkUpdateOrdersInput): Promise<void> =>
    this.#requestInstance.patch(ordersEndpoints.orders, input);

  updateOrder = async (input: UpdateOrderInput): Promise<void> =>
    this.#requestInstance.patch(ordersEndpoints.ordersId(input.id), input);
}

export const ordersApi = new OrdersApi(axios);
